export const SELECTION_TOOL_FILL_COLOR = 'rgba(0, 102, 255, 0.1)' as const;
export const SELECTION_TOOL_STROKE_COLOR = '#0066ff' as const;
export const NUMBERING_TOOL_STROKE_COLOR = '#00ff00' as const;
export const SELECTION_STROKE_COLOR = '#0D99FF';

export const DEFAULT_NODE_LABEL_ALIGNMENT = 'center' as const;
export const DEFAULT_FONT_FAMILY = 'Quicksand' as const;

export const DEFAULT_NODE_CIRCLE_RADIUS = 28;
export const DEFAULT_NODE_CIRCLE_STROKE_WIDTH = 8;

export const DEFAULT_NODE_RECT_COLOR = '#E8ECEF';
export const DEFAULT_NODE_TEXT_COLOR = '#6B6B6B';

export const DEFAULT_TEXT_SHAPE_COLOR = '#6B6B6B';
export const DEFAULT_TEXT_SHAPE_FONT_SIZE = 16;

export const DEFAULT_FURNITURE_FILL_COLOR = '#E8ECEF';
export const DEFAULT_FURNITURE_TEXT_COLOR = '#6B6B6B';

export const DEFAULT_ICON_FILL_COLOR = '#D1D5D9';
export const DEFAULT_ICON_TEXT_COLOR = '#6B6B6B';

export const EDITING_ZONE_MAX_WIDTH = 15000;
export const EDITING_ZONE_MAX_HEIGHT = 15000;
